// extracted by mini-css-extract-plugin
export default {"wrapper":"EjYtV6h6oU19TA1nGrt2","homeLink":"RQa4hKwIJliuTtFrJghl"};